module.exports = __webpack_public_path__ + "static/media/steakhouse_teen-mb-en.152e3bf9.jpg";